import { useTableActionContext } from '@aibees/elephant/context';
import { SearchType } from '@aibees/elephant/types';
import { useMemo } from 'react';
import {
  DEFAULT_COMPANY_EXPORT_TEMPLATE,
  DEFAULT_INTEGRATION_EXPORT_TEMPLATE,
  DEFAULT_PEOPLE_EXPORT_TEMPLATE,
} from '../constants';

export function useDefaultTemplateData() {
  // Use the flow's effective search type (folds in the ActionButton override) so
  // the default template matches the record, not just the page route.
  const { integrationConfig, effectiveSearchType } = useTableActionContext();

  return useMemo(() => {
    if (integrationConfig) {
      return DEFAULT_INTEGRATION_EXPORT_TEMPLATE;
    }

    return effectiveSearchType === SearchType.People
      ? DEFAULT_PEOPLE_EXPORT_TEMPLATE
      : DEFAULT_COMPANY_EXPORT_TEMPLATE;
  }, [integrationConfig, effectiveSearchType]);
}
